var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"content aui-content"},[_c('Header'),_c('div',{staticClass:"content_body"},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }